<script lang="ts" setup>
import { IonIcon, IonRippleEffect } from "@ionic/vue";
import { peopleOutline } from "ionicons/icons";
import { useRouter } from "vue-router";

const router = useRouter();
const props = defineProps({
    targetRoute: {
        type: String,
        required: true,
    },
    icon: {
        type: String,
        required: false,
        default: () => peopleOutline,
    },
    label: {
        type: String,
        required: true,
    },
});

const redirect = () => {
    router.push({ name: props.targetRoute });
};
</script>

<template>
    <a
        @click="redirect"
        style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;
            z-index: 1;
        "
        :data-route-target="targetRoute">
        <div
            class="ion-activatable ripple-parent"
            style="
                background-color: black;
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                border-radius: 30px;
                justify-content: center;
                overflow: hidden;
                border: 2px solid var(--ion-color-primary);
            ">
            <ion-ripple-effect></ion-ripple-effect>
            <div style="height: fit-content">
                <ion-icon size="large" :icon="icon"></ion-icon>
            </div>

            <span style="display: block">{{ label }}</span>
        </div>
    </a>
</template>
